module.exports = __webpack_public_path__ + "img/homebg4.4a81172c.png";